// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "input.value.vector3D {\n  width: 16% !important;\n}\ninput.value.vector3D.x,\ninput.value.vector3D.y {\n  margin-left: 2%;\n}\n", ""]);
// Exports
module.exports = exports;
